// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Cashflows_CashflowFragment = { __typename?: 'Cashflow', id: string, displayName: string, afterBothDeaths?: boolean | null, transferValue?: CurrencyUSD | null, transferPercentage?: Percent | null, endYear?: number | null, startYear?: number | null, growthPercent?: Percent | null, endAtClientsDeath?: { __typename?: 'ClientProfile', id: string, firstName: string } | null, entity?: { __typename?: 'Entity', id: string, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, integrationCashflow?: { __typename?: 'IntegrationCashflow', id: string } | null };

export type CashflowQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CashflowWhereInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CashflowQuery = { __typename?: 'Query', cashflows: { __typename?: 'CashflowConnection', edges?: Array<{ __typename?: 'CashflowEdge', node?: (
        { __typename?: 'Cashflow' }
        & Cashflows_CashflowFragment
      ) | null } | null> | null } };

export type CreateCashflowMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateCashflowInput;
}>;


export type CreateCashflowMutation = { __typename?: 'Mutation', createCashflow: (
    { __typename?: 'Cashflow' }
    & Cashflows_CashflowFragment
  ) };

export type UpdateCashflowMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateCashflowInput;
}>;


export type UpdateCashflowMutation = { __typename?: 'Mutation', updateCashflow: (
    { __typename?: 'Cashflow' }
    & Cashflows_CashflowFragment
  ) };

export type DeleteCashflowMutationVariables = Types.Exact<{
  cashflowId: Types.Scalars['ID']['input'];
}>;


export type DeleteCashflowMutation = { __typename?: 'Mutation', deleteCashflows: number };

export const Operations = {
  Query: {
    Cashflow: 'Cashflow' as const
  },
  Mutation: {
    CreateCashflow: 'CreateCashflow' as const,
    UpdateCashflow: 'UpdateCashflow' as const,
    DeleteCashflow: 'DeleteCashflow' as const
  },
  Fragment: {
    Cashflows_Cashflow: 'Cashflows_Cashflow' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const Cashflows_CashflowFragmentDoc = gql`
    fragment Cashflows_Cashflow on Cashflow {
  id
  displayName
  afterBothDeaths
  transferValue
  transferPercentage
  endAtClientsDeath {
    id
    firstName
  }
  entity {
    id
    stage
    subtype {
      id
      displayName
    }
  }
  individual {
    id
    displayName
  }
  endYear
  startYear
  growthPercent
  integrationCashflow {
    id
  }
}
    `;
export const CashflowDocument = gql`
    query Cashflow($where: CashflowWhereInput, $first: Int = 1) {
  cashflows(where: $where, first: $first) {
    edges {
      node {
        ...Cashflows_Cashflow
      }
    }
  }
}
    ${Cashflows_CashflowFragmentDoc}`;

/**
 * __useCashflowQuery__
 *
 * To run a query within a React component, call `useCashflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashflowQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCashflowQuery(baseOptions?: Apollo.QueryHookOptions<CashflowQuery, CashflowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashflowQuery, CashflowQueryVariables>(CashflowDocument, withFetchPolicyContext(options));
      }
export function useCashflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashflowQuery, CashflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashflowQuery, CashflowQueryVariables>(CashflowDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCashflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashflowQuery, CashflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashflowQuery, CashflowQueryVariables>(CashflowDocument, withFetchPolicyContext(options));
        }
export type CashflowQueryHookResult = ReturnType<typeof useCashflowQuery>;
export type CashflowLazyQueryHookResult = ReturnType<typeof useCashflowLazyQuery>;
export type CashflowSuspenseQueryHookResult = ReturnType<typeof useCashflowSuspenseQuery>;
export type CashflowQueryResult = Apollo.QueryResult<CashflowQuery, CashflowQueryVariables>;
export const CreateCashflowDocument = gql`
    mutation CreateCashflow($input: AugmentedCreateCashflowInput!) {
  createCashflow(input: $input) {
    ...Cashflows_Cashflow
  }
}
    ${Cashflows_CashflowFragmentDoc}`;
export type CreateCashflowMutationFn = Apollo.MutationFunction<CreateCashflowMutation, CreateCashflowMutationVariables>;

/**
 * __useCreateCashflowMutation__
 *
 * To run a mutation, you first call `useCreateCashflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCashflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCashflowMutation, { data, loading, error }] = useCreateCashflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCashflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateCashflowMutation, CreateCashflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCashflowMutation, CreateCashflowMutationVariables>(CreateCashflowDocument, options);
      }
export type CreateCashflowMutationHookResult = ReturnType<typeof useCreateCashflowMutation>;
export type CreateCashflowMutationResult = Apollo.MutationResult<CreateCashflowMutation>;
export type CreateCashflowMutationOptions = Apollo.BaseMutationOptions<CreateCashflowMutation, CreateCashflowMutationVariables>;
export const UpdateCashflowDocument = gql`
    mutation UpdateCashflow($input: AugmentedUpdateCashflowInput!) {
  updateCashflow(input: $input) {
    ...Cashflows_Cashflow
  }
}
    ${Cashflows_CashflowFragmentDoc}`;
export type UpdateCashflowMutationFn = Apollo.MutationFunction<UpdateCashflowMutation, UpdateCashflowMutationVariables>;

/**
 * __useUpdateCashflowMutation__
 *
 * To run a mutation, you first call `useUpdateCashflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCashflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCashflowMutation, { data, loading, error }] = useUpdateCashflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCashflowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCashflowMutation, UpdateCashflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCashflowMutation, UpdateCashflowMutationVariables>(UpdateCashflowDocument, options);
      }
export type UpdateCashflowMutationHookResult = ReturnType<typeof useUpdateCashflowMutation>;
export type UpdateCashflowMutationResult = Apollo.MutationResult<UpdateCashflowMutation>;
export type UpdateCashflowMutationOptions = Apollo.BaseMutationOptions<UpdateCashflowMutation, UpdateCashflowMutationVariables>;
export const DeleteCashflowDocument = gql`
    mutation DeleteCashflow($cashflowId: ID!) {
  deleteCashflows(ids: [$cashflowId])
}
    `;
export type DeleteCashflowMutationFn = Apollo.MutationFunction<DeleteCashflowMutation, DeleteCashflowMutationVariables>;

/**
 * __useDeleteCashflowMutation__
 *
 * To run a mutation, you first call `useDeleteCashflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCashflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCashflowMutation, { data, loading, error }] = useDeleteCashflowMutation({
 *   variables: {
 *      cashflowId: // value for 'cashflowId'
 *   },
 * });
 */
export function useDeleteCashflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCashflowMutation, DeleteCashflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCashflowMutation, DeleteCashflowMutationVariables>(DeleteCashflowDocument, options);
      }
export type DeleteCashflowMutationHookResult = ReturnType<typeof useDeleteCashflowMutation>;
export type DeleteCashflowMutationResult = Apollo.MutationResult<DeleteCashflowMutation>;
export type DeleteCashflowMutationOptions = Apollo.BaseMutationOptions<DeleteCashflowMutation, DeleteCashflowMutationVariables>;